module.exports = __webpack_public_path__ + "font/fontello.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_mavon-editor@2.9.1@mavon-editor/dist/font/fontello.ttf
// module id = 45
// module chunks = 0